import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

export class BusinessSelectOptionView {
    value: string;
    label: MessageBaseView;

    constructor(data?: any) {
        this.value = data?.value.toString() ?? "";
        this.label = data?.label ? new MessageBaseView(data.label) : new MessageBaseView();
    }
}
